import * as React from 'react';

import BaseSalesListLayout from './BaseSalesListLayout';
import SalePrintResultPopup from '~/apps/pos/admin/containers/sales/SalePrintResultPopup';

export default function () {
  return BaseSalesListLayout(
    <SalePrintResultPopup />
  );
};
